<template>
  <div class="page-content">
    <el-breadcrumb separator="/" class="breadcrumb">
      <el-breadcrumb-item>{{logintype=='SHOP'||logintype=='DEALER'?"违规举报":'违规处理'}}</el-breadcrumb-item>
      <el-breadcrumb-item>违规信息列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-button type="primary" size="mini" @click="downloadShow" style="position: absolute;right: 20px;top: 20px;z-index: 99;">整合下载</el-button>
    <el-tabs v-model="messageType" type="card" style="background-color: white;padding: 20px;" @tab-click="eltabsChage">
      <el-tab-pane label="举报信息审核" name="message1">
        <section class="seaerch-wrapper">
          <!--查询-->
          <headerSearch
            @searchTable="onTabClick"
            :dealState="dealState"
            :productShow="true"
            :dealerShow="true"
            ref="refheader"
          ></headerSearch>
        </section>
        <section class="content-warpper">
          <el-tabs v-model="activeName" @tab-click="onTabClick">
            <el-tab-pane :label="'待初审('+firstTotal+')'" name="first">
              <checkTable activeName="first" ref="checkOne" v-model="firstTotal" @loadDataPage='loadDataPage' ></checkTable>
            </el-tab-pane>
            <el-tab-pane :label="'异常举报('+secondTotal+')'" name="second">
              <checkTable
                activeName="second"
                ref="checkTwo"
                v-model="secondTotal"
                @loadDataPage='loadDataPage'
              ></checkTable>
            </el-tab-pane>
          </el-tabs>
        </section>
      </el-tab-pane>
      <el-tab-pane label="授权违规处理" name="message2">
        <deal ref="cgDeal"/>
      </el-tab-pane>
      <el-tab-pane label="非授权违规处理" name="message3">
        <noDeal ref="cgnoDeal"/>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      :visible.sync="downloadVisible"
      title="整合下载"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form
        label-width="60px"
      >
        <el-form-item :required="true" label="时间">
          <el-date-picker
            v-model="dateTime"
            size="small"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            range-separator="~"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button
          size="small"
          class="g-confirm-btn"
          @click="download"
          type="confire_btn"
          :loading="downloadLoading"
        >下 载</el-button>
        <el-button size="small" class="g-cancel-btn" @click="downloadVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import headerSearch from "../common/headerSearch";
import { mapMutations, mapActions, mapState } from "vuex";
import checkTable from "./checkTable";
import { getLoginType } from "@/libs/until";
import deal from "../CreditScoreDeal/deal.vue";
import noDeal from "../UnAccredit/index.vue";

export default {
  components: { headerSearch, checkTable, deal, noDeal },
  data() {
    return {
      messageType: 'message1',
      dealState: false,
      activeName: "first",
      unusuaNum: 0,
      firstTotal: 0,
      secondTotal: 0,
      logintype:getLoginType(),
      downloadVisible: false,
      dateTime: [],
      downloadLoading: false,
    };
  },
  mounted() {
    this.changeCompleteShow();
  },
  methods: {
    // 分页调用每个页面的方法
    eltabsChage() {
      if (this.messageType == 'message1') {
        this.onTabClick()
      } else if (this.messageType == 'message2') {
        this.$refs.cgDeal.onTabClick()
      } else {
        this.$refs.cgnoDeal.searchTable()
      }
    },
    downloadShow() {
      this.dateTime = []
      this.downloadVisible = true
    },
    // 下载
		download() {
      if (this.dateTime.length == 0) {
        this.$message({
          message: '请选择时间',
          type: 'warning'
        });
        return
      }
      this.downloadLoading = true
      let data = {
        starttime: this.dateTime[0],
        endtime: this.dateTime[1]
      }
			fetch({
        url: "hcm/hcmReport/downloadReportPage",
        method: "get",
        params: data,
        noFormat: true,
        responseType: "blob"
			})
			.then((res)=>{
				//下载
				let url = window.URL.createObjectURL(new Blob([res]))
				let link = document.createElement('a')
				link.style.display = 'none'
				link.href = url
				link.setAttribute('download', '整合下载.xlsx')
				document.body.appendChild(link)
				link.click()
        this.downloadLoading = false
			})
		},
    ...mapMutations(["changeCompleteShow",'changenormaltableLoading']),
    loadDataPage(){
      this.$refs.checkOne.loadData();
       this.$refs.checkTwo.loadData();
    },
    onTabClick(val) {
       this.changenormaltableLoading(true)
      if (this.activeName === "first") {
        this.$refs.checkOne.loadData();
      } else {
        this.$refs.checkTwo.loadData();
      }
    }
  },
  beforeDestroy() {
    this.changeCompleteShow();
  }
};
</script>
